import React from 'react';
import { JobSelectorProps } from '../types';
import Typography from '../../../basic/Typography';
import styles from '../NewsEditor.module.css';

const JobSelector: React.FC<JobSelectorProps> = ({
  jobs,
  currentJob,
  onJobSelect,
  isLoading
}) => {
  const handleJobChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedJob = jobs.find(job => job.job_id === event.target.value);
    if (selectedJob) {
      onJobSelect(selectedJob);
    }
  };

  const formatJobDate = (dateString?: string) => {
    if (!dateString) return 'Unknown date';
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'completed':
        return 'var(--color-success)';
      case 'processing':
        return 'var(--color-warning)';
      case 'failed':
        return 'var(--color-error)';
      case 'pending':
        return 'var(--color-text-secondary)';
      default:
        return 'var(--color-text-secondary)';
    }
  };

  if (isLoading) {
    return (
      <div className={styles['job-selector']}>
        <div className={styles['job-selector-loading']}>
          <div className={styles['loading-spinner']}></div>
          <span>Loading jobs...</span>
        </div>
      </div>
    );
  }

  if (jobs.length === 0) {
    return (
      <div className={styles['job-selector']}>
        <div className={styles['job-selector-empty']}>
          <p>No jobs available</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles['job-selector']}>
              <div className={styles['job-selector-header']}>
          <Typography variant="h3">Select Job to Edit</Typography>
          <Typography variant="caption" color="secondary" className={styles['job-count']}>{jobs.length} job{jobs.length !== 1 ? 's' : ''} available</Typography>
        </div>

      <div className={styles['job-selector-controls']}>
        <select
          className={styles['job-selector-dropdown']}
          value={currentJob?.job_id || ''}
          onChange={handleJobChange}
          disabled={isLoading}
        >
          <option value="">Select a job...</option>
          {jobs.map((job) => (
            <option key={job.job_id} value={job.job_id}>
              {job.job_id} - {formatJobDate(job.created_at)} - {job.overall_status}
            </option>
          ))}
        </select>

        {currentJob && (
          <div className={styles['current-job-info']}>
            <div className={styles['job-status']}>
              <span
                className={styles['status-indicator']}
                style={{ backgroundColor: getStatusColor(currentJob.overall_status) }}
              ></span>
              <span className={styles['status-text']}>{currentJob.overall_status}</span>
            </div>
            <div className={styles['job-dates']}>
              <span>Created: {formatJobDate(currentJob.created_at)}</span>
              <span>Updated: {formatJobDate(currentJob.updated_at)}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default JobSelector;
